export default {
  pages: {
    applicationsShow: {
      pageTabs: ['О заявке', 'Детали и график оплаты'],
      applicationItemsTable: {
        title: 'Удаленные товары',
      },
      statusChangedToast: 'Статус заявки изменен',
    },
  },
};
